<template>
    <div class="voice">
        <!-- <p>{{ fullscript }}</p> -->
        <v-row justify="center">
            <v-col cols="12" sm="10" md="10" class="mr-2">
                <!-- <v-card class="box"> -->
                <v-row justify="center">
                    <v-col cols="12" sm="4" md="4" class="mr-2">
                        <v-select
                            :items="languages"
                            v-model="lang_"
                            label="Select Language"
                            dense
                            outlined
                            >
                        </v-select>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" class="mr-2">
                        <v-btn small outlined rounded color="primary" @click="startSpeechToTxt();dialog=true"> <v-icon small>mdi-microphone</v-icon> Speech To Text</v-btn>
                    </v-col>
                </v-row>

                <!-- {{ flag }} -->
                <v-row justify="center">
                    <v-col cols="12" sm="12" md="12">
                        <!-- <v-textarea outlined  clearable dense  persistent-hint hint="Edit Text" v-model="fullscript" @click="fullscript"></v-textarea> -->
                        <v-textarea outlined  clearable dense  persistent-hint hint="Edit Text" v-model="fullscript"></v-textarea>
                    </v-col>
                    <v-col cols="12" sm="4" md="4" align="center">
                        <!-- <v-btn @click="copy" small rounded outlined color="warning"><v-icon small>mdi-content-copy</v-icon>Copy Text</v-btn> -->
                        <v-btn v-if="fullscript!=''" @click="copy(fullscript)" small rounded outlined color="warning"><v-icon small>mdi-content-copy</v-icon>Copy Text</v-btn>
                    </v-col>
                </v-row>
                <v-dialog v-model="dialog" width="100px" v-if="flag">
                    <v-img height="120" width="150" v-if="flag" src="https://eduplusschool.s3.ap-south-1.amazonaws.com/s2t.gif" />
                </v-dialog>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import "@/assets/css/color.css";
    export default {
        name: "speech_to_text",
        data() {
            return {
                runtimeTranscription_: "",
                transcription_: [],
                languages: [
                    { text: "English", value: "en-IN" },
                    { text: "Marathi", value: "mr-IN" },
                    { text: "Hindi", value: "hi-IN" }
                ],
                flag: false,
                fullscript: "",
                o1: "",
                txt_c2p: "",
                dialog: false,
            };
        },
        mounted() {},
        methods: {
            copy(link) {
                navigator.clipboard.writeText(link);
                alert("Text copied to clipboard!!!");
            },
            // copy() {
            //     this.$emit("getvalfromchld", this.fullscript);
            // },
            startSpeechToTxt() {
                // initialisation of voicereco

                window.SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
                const recognition = new window.SpeechRecognition();
                recognition.lang = this.lang_;
                recognition.interimResults = true;

                // event current voice reco word
                recognition.addEventListener("result", (event) => {
                    var text = Array.from(event.results)
                        .map((result) => result[0])
                        .map((result) => result.transcript)
                        .join("");
                    this.runtimeTranscription_ = text;
                });
                // end of transcription
                recognition.addEventListener("end", () => {
                    this.transcription_.push(this.runtimeTranscription_);
                    if (this.fullscript == "") this.fullscript = this.runtimeTranscription_;
                    else this.fullscript = this.fullscript + ". " + this.runtimeTranscription_;
                    this.runtimeTranscription_ = "";
                    recognition.stop();
                    this.flag = false;
                });
                recognition.start();
                this.flag = true;
                // this.dialog = true;
            },
        },
    };
</script>
